// extracted by mini-css-extract-plugin
export default {"title":"styles_title__rmibQ","mainContent":"styles_mainContent__r35y4","addRowButtonWrapper":"styles_addRowButtonWrapper__G3V9v","bottom":"styles_bottom__6kJKh"};